var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 3.125H12.5C7.1875 3.125 3.125 7.1875 3.125 12.5V20.3125H96.875V12.5C96.875 7.1875 92.8125 3.125 87.5 3.125ZM17.8125 19.0625C16.25 19.0625 14.6875 17.5 14.6875 15.9375C14.6875 14.375 16.25 12.8125 17.8125 12.8125C19.375 12.8125 20.9375 14.0625 20.9375 15.9375C20.9375 17.8125 19.6875 19.0625 17.8125 19.0625ZM28.75 19.0625C26.875 19.0625 25.625 17.5 25.625 15.9375C25.625 14.375 26.875 12.8125 28.75 12.8125C30.3125 12.8125 31.875 14.0625 31.875 15.9375C31.875 17.8125 30.3125 19.0625 28.75 19.0625ZM39.375 19.0625C37.8125 19.0625 36.25 17.5 36.25 15.9375C36.25 14.375 37.5 12.8125 39.375 12.8125C41.25 12.8125 42.5 14.0625 42.5 15.9375C42.5 17.8125 41.25 19.0625 39.375 19.0625ZM9.375 26.5625H3.125V87.5C3.125 92.8125 7.1875 96.875 12.5 96.875H87.5C92.8125 96.875 96.875 92.8125 96.875 87.5V26.5625H90.625H9.375ZM19.0625 60.9375C19.0625 55 23.75 50.3125 29.6875 50.3125H40.9375C41.875 45 46.25 41.25 51.5625 41.25H70.3125C76.25 41.25 80.9375 45.9375 80.9375 51.875V56.5625C80.9375 62.5 76.25 67.1875 70.3125 67.1875H59.0625C58.125 72.5 53.75 76.25 48.4375 76.25H29.6875C23.75 76.25 19.0625 71.5625 19.0625 65.625V60.9375Z",
    fill: "url(#paint0_linear_4_32505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 70H48.4375C50.3125 70 51.875 68.75 52.5 67.1875H51.5625C45.625 67.1875 40.9375 62.5 40.9375 56.5625H29.6875C27.1875 56.5625 25.3125 58.4375 25.3125 60.9375V65.625C25.3125 68.125 27.1875 70 29.6875 70ZM51.5625 60.9375H52.8125C52.8125 58.4375 50.9375 56.5625 48.4375 56.5625H47.1875C47.1875 59.0625 49.0625 60.9375 51.5625 60.9375ZM59.0625 60.9375H70.3125C72.8125 60.9375 74.6875 59.0625 74.6875 56.5625V51.875C74.6875 49.375 72.8125 47.5 70.3125 47.5H51.5625C49.6875 47.5 48.125 48.75 47.5 50.3125H48.4375C54.375 50.3125 59.0625 55 59.0625 60.9375Z",
    fill: "url(#paint1_linear_4_32505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_32505",
    x1: 3.125,
    y1: 3.23318,
    x2: 110.84,
    y2: 112.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_32505",
    x1: 25.3125,
    y1: 47.526,
    x2: 44.6858,
    y2: 90.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBuilding);
export default __webpack_public_path__ + "static/media/Link-Building.e47870319195780c7b3dccf9a820f335.svg";
export { ForwardRef as ReactComponent };